import { motion } from 'framer-motion';
import { CHOICES, CHOICE_EMOJIS, determineRoundWinner } from './logic';
import { safeString } from '../../utils/safeString';
import './RPSBoard.css';

const RPSBoard = ({ myChoice, opponentChoice, bothChosen, showResult, onChoice, onNextRound, opponent, isHost }) => {
  const choices = [
    { id: CHOICES.ROCK, emoji: CHOICE_EMOJIS.rock, label: 'Rock' },
    { id: CHOICES.PAPER, emoji: CHOICE_EMOJIS.paper, label: 'Paper' },
    { id: CHOICES.SCISSORS, emoji: CHOICE_EMOJIS.scissors, label: 'Scissors' },
  ];

  // Determine who won this round
  let roundResult = null;
  if (bothChosen && showResult) {
    const player1Choice = isHost ? myChoice : opponentChoice;
    const player2Choice = isHost ? opponentChoice : myChoice;
    const winner = determineRoundWinner(player1Choice, player2Choice);

    if (winner === 'tie') {
      roundResult = 'tie';
    } else if ((winner === 'player1' && isHost) || (winner === 'player2' && !isHost)) {
      roundResult = 'won';
    } else {
      roundResult = 'lost';
    }
  }

  return (
    <div className="rps-board">
      {/* Choice Selection */}
      {!myChoice && !bothChosen && (
        <div className="choice-section">
          <h2 className="choice-title">Make Your Choice!</h2>
          <div className="choice-grid">
            {choices.map((choice) => (
              <motion.button
                key={choice.id}
                className="choice-button"
                onClick={() => onChoice(choice.id)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
              >
                <span className="choice-emoji">{choice.emoji}</span>
                <span className="choice-label">{choice.label}</span>
              </motion.button>
            ))}
          </div>
        </div>
      )}

      {/* Waiting for Opponent */}
      {myChoice && !bothChosen && (
        <div className="waiting-section">
          <motion.div
            className="waiting-animation"
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          >
            <span className="chosen-emoji">{CHOICE_EMOJIS[myChoice]}</span>
          </motion.div>
          <h2>You chose {myChoice}!</h2>
          <p>Waiting for {safeString(opponent?.displayName, 'Opponent')}...</p>
        </div>
      )}

      {/* Show Result */}
      {bothChosen && showResult && (
        <div className="result-section">
          <div className={`round-result-banner ${roundResult}`}>
            {roundResult === 'won' && <h2>🎉 You Won This Round!</h2>}
            {roundResult === 'lost' && <h2>😞 You Lost This Round</h2>}
            {roundResult === 'tie' && <h2>🤝 It's a Tie!</h2>}
          </div>

          <div className="choices-display">
            <div className="choice-display">
              <span className="result-emoji">{CHOICE_EMOJIS[myChoice]}</span>
              <p className="choice-name">You</p>
              <p className="choice-text">{myChoice}</p>
            </div>

            <div className="vs-text">VS</div>

            <div className="choice-display">
              <span className="result-emoji">{CHOICE_EMOJIS[opponentChoice]}</span>
              <p className="choice-name">{safeString(opponent?.displayName, 'Opponent')}</p>
              <p className="choice-text">{opponentChoice}</p>
            </div>
          </div>

          <button className="next-round-button" onClick={onNextRound}>
            Next Round →
          </button>
        </div>
      )}
    </div>
  );
};

export default RPSBoard;
